import presentationHeader from "./presentation-header.png";
import dashboardPlug from "./dashboard-plug.svg";
import dashboardEmpty from "./dashboard-empty.svg";

export const images = {
  dashboardPlug,
  dashboardEmpty,
  presentationHeader,
};
